export default "__VITE_ASSET__DliYErZ5__"